import React from "react";
import { FaFileAlt } from "react-icons/fa";

const Desc: React.FC = () => {
  return (
    <div className="w-full p-6  rounded-lg shadow-md bg-gradient-to-r from-slate-50 to-slate-100">
      <div className="flex items-start gap-4">
        <div className="rounded-lg bg-blue-100 p-3">
          <FaFileAlt className="h-6 w-6 text-blue-600" />
        </div>
        <div className="flex items-center">
          {/* <h2 className="text-2xl font-semibold text-slate-800 mb-2">
            Sales Representative
          </h2> */}
          <p className="text-slate-600 leading-relaxed">
            Click on "View Reports" to access a comprehensive overview of all
            sales representative customer interactions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Desc;
